import { render, staticRenderFns } from "./dispatchReciveOrder.vue?vue&type=template&id=7e1236f4&scoped=true&"
import script from "./dispatchReciveOrder.vue?vue&type=script&lang=js&"
export * from "./dispatchReciveOrder.vue?vue&type=script&lang=js&"
import style0 from "./dispatchReciveOrder.vue?vue&type=style&index=0&id=7e1236f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1236f4",
  null
  
)

export default component.exports